import FVector from '@data/geometry/FVector';
import { SensorData } from 'Simulations/SensorPoint';
import { CONTEXT_KEYS, ContextHelper, StageContext } from '../../Context';
import { PreprocessStage, StageParameters } from '../../Stage';

interface AverageParams extends StageParameters {}

class AverageStage extends PreprocessStage<AverageParams> {
    constructor() {
        super({});
    }

    protected override transformContext(input: StageContext): StageContext {
        ContextHelper.set(input, CONTEXT_KEYS.AVERAGE, this.computeAverage(input.sensors));
        return input;
    }
    /**
     * Compute average out of a list of sensor datas and return it
     * @param sensors
     * @returns
     */
    private computeAverage(sensors: SensorData[]): FVector {
        const average = sensors
            .map((sensor) => sensor.getVectorialResult())
            .reduce((previous, current) => {
                return FVector.add(previous, current);
            }, new FVector())
            .div(sensors.length);

        return average;
    }
}

export default AverageStage;
